import { ReactNode } from "react";
import { Box, Flex } from "flux";

import TitleBar from "./title-bar";
import PageHeader from "./page-header";

export interface PageProps {
  title: string;
  description?: string;
  subDescription?: string;
  descriptionLoading?: boolean;
  backLinkText?: string;
  backLinkPath?: string;
  testId?: string;
  children?: ReactNode;
  titleBarActions?: ReactNode;
  showSubDescriptionOnHeader?: boolean;
}

export const PagePadding = 48;

const Page = ({
  title,
  description,
  backLinkText,
  backLinkPath,
  testId,
  children,
  titleBarActions,
  subDescription,
  descriptionLoading,
  showSubDescriptionOnHeader
}: PageProps) => {
  return (
    <Box position="relative">
      <TitleBar backLinkText={backLinkText} backLinkPath={backLinkPath}>
        {titleBarActions}
      </TitleBar>
      <Flex flexDirection="column" flexGrow={1} pt="32px" px={`${PagePadding}px`}>
        <PageHeader
          title={title}
          description={description}
          subDescription={subDescription}
          descriptionLoading={descriptionLoading}
          testId={testId}
          showSubDescriptionOnHeader={showSubDescriptionOnHeader}
        />
        {children}
      </Flex>
    </Box>
  );
};

export default Page;
